import React from "react";
import { ErrorMessage, Field } from "formik";
import { generalInfoType, iCommunityProfile } from "ps-shared";
import { FormikMultiCreateSelect } from "src/components/Forms/FormikMultiCreateSelect";
import CheckboxGroup from "src/components/Forms/FormikCheckboxGroup";
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface GeneralInfoProps {
  values: generalInfoType;
  profile: iCommunityProfile;
}

// tslint:disable-next-line:no-empty-interface
interface GeneralInfoState {}
export class GeneralInfo extends React.Component<GeneralInfoProps, GeneralInfoState> {
  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3">
          <Label for="name">Group Name:</Label>
          <br />
          <Field
            placeholder="Community Group Name"
            type="text"
            name="name"
            component="input"
            className="form-control"
            autoComplete="groupName"
          />
          <ErrorMessage name="name" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="firstName">Contact First Name:</Label>
          <br />
          <Field
            placeholder="Group Contact First Name"
            type="text"
            component="input"
            name="firstName"
            autoComplete="given-name"
            className="form-control"
          />
          <ErrorMessage name="firstName" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="lastName">Contact Last Name:</Label>
          <br />
          <Field
            placeholder="Group Contact Last Name"
            type="text"
            name="lastName"
            component="input"
            className="form-control"
            autoComplete="family-name"
          />
          <ErrorMessage name="lastName" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="phone">Phone:</Label>
          <br />
          <Field
            placeholder="Phone"
            type="text"
            name="phone"
            component="input"
            className="form-control"
            autoComplete="phone"
          />
          <ErrorMessage name="phone" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="email">
            Group Email:&nbsp;<i>(hidden from public)</i>
          </Label>
          <br />
          <Field
            placeholder="Group Email"
            type="text"
            name="email"
            component="input"
            className="form-control"
            autoComplete="email"
          />
          <ErrorMessage name="email" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="preferredContact">Preferred Contact:</Label>
          <br />
          <CheckboxGroup name="preferredContact" value="email" label="Email" />
          <CheckboxGroup name="preferredContact" value="phone" label="Phone" />
          <ErrorMessage name="preferredContact" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="websiteTT">
            Copy/paste the url here. It requires the full link from your browser including http:// or https://
          </UncontrolledTooltip>
          <Label for="web">Group Website and Social Media Page(s):</Label>&nbsp;
          <span id="websiteTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiCreateSelect
            options={[]}
            value={this.props.values.web}
            name="web"
            noOptionsMessage="Add your website(s)"
            validationFunc={(value: string): boolean => {
              try {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const url = new URL(value);
                return true;
              } catch {
                return false;
              }
            }}
            customErr="Invalid URL, please be sure to prefix with the protocol eg http:// or https://"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="programs">Group Description:</Label>
          <br />
          <Field
            placeholder="Tell us more about your community group"
            type="text"
            name="bio"
            component="textarea"
            className="form-control"
          />
          <ErrorMessage name="bio" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="programs">Programs offered:</Label>
          <br />
          <Field
            placeholder="Describe your community group programs"
            type="text"
            name="programs"
            component="textarea"
            className="form-control"
          />
          <ErrorMessage name="programs" component="div" className="position-relative form-feedback" />
        </FormGroup>
      </>
    );
  }
}
